import { ServiceExtent, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useServicesGetAll = (serviceId: string, extent?: Partial<ServiceExtent>) => {
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositorySuspenseQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            serviceIds: [serviceId],
            extent: {
                products: false,
                productCategories: false,
                businessSegments: false,
                vouchers: false,
                registrationCardConfigurations: false,
                bookingEngines: false,
                ageCategories: false,
                ...(extent || {}),
            },
        },
        {
            select: (data) => ({
                ...data,
                service: data.services?.find((s) => s.id === serviceId),
            }),
        }
    );
};
